import React, { forwardRef } from 'react';
import * as AccordionPrimitive from '@radix-ui/react-accordion';
import { CircleDot, Circle, ChevronDown } from 'lucide-react';
import { cn } from '../../../lib/utils';

interface KYPAccordionTriggerProps extends React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Trigger> {
  hasData: boolean;
}

export const KYPAccordionTrigger = forwardRef<
  React.ElementRef<typeof AccordionPrimitive.Trigger>,
  KYPAccordionTriggerProps
>(({ className, children, hasData, ...props }, ref) => (
  <AccordionPrimitive.Header className="flex">
    <AccordionPrimitive.Trigger
      ref={ref}
      className={cn(
        'flex flex-1 items-center justify-between py-4 font-medium transition-all text-[#CECFD2]',
        'hover:bg-[#26222E]',
        !hasData && 'cursor-default',
        className,
      )}
      {...props}
    >
      <div className="flex items-center gap-2">
        {hasData ? (
          <CircleDot className="h-4 w-4 text-[#4E46FF]" />
        ) : (
          <Circle className="h-4 w-4 text-gray-600" />
        )}
        {children}
      </div>
      {hasData && (
        <ChevronDown className="h-4 w-4 shrink-0 transition-transform duration-200 [&[data-state=open]>svg]:rotate-180" />
      )}
    </AccordionPrimitive.Trigger>
  </AccordionPrimitive.Header>
));